import type React from "react";

import { HelpIcon, type HelpIconProps } from "src/shared/HelpIcon";
import {
  Field as ShadcnField,
  FieldLabel as ShadcnFieldLabel,
  FieldDescription as ShadcnFieldDescription,
  FieldError as ShadcnFieldError,
  FieldGroup as ShadcnFieldGroup,
  FieldLegend as ShadcnFieldLegend,
  FieldSeparator as ShadcnFieldSeparator,
  FieldSet as ShadcnFieldSet,
  FieldContent as ShadcnFieldContent,
  FieldTitle as ShadcnFieldTitle,
} from "src/shadcn/components/field";

const Field = (props: React.ComponentProps<typeof ShadcnField>) => (
  <ShadcnField {...props} />
);

type FieldLabelProps = React.ComponentProps<typeof ShadcnFieldLabel> & {
  /** Props for the help icon (tooltip or popover mode). */
  helpIconProps?: HelpIconProps;
};

const FieldLabel = ({ helpIconProps, children, ...props }: FieldLabelProps) => (
  <ShadcnFieldLabel {...props}>
    {children}
    {helpIconProps && <HelpIcon {...helpIconProps} />}
  </ShadcnFieldLabel>
);

const FieldDescription = (
  props: React.ComponentProps<typeof ShadcnFieldDescription>
) => <ShadcnFieldDescription {...props} />;

const FieldError = (props: React.ComponentProps<typeof ShadcnFieldError>) => (
  <ShadcnFieldError {...props} />
);

const FieldGroup = (props: React.ComponentProps<typeof ShadcnFieldGroup>) => (
  <ShadcnFieldGroup {...props} />
);

const FieldLegend = (props: React.ComponentProps<typeof ShadcnFieldLegend>) => (
  <ShadcnFieldLegend {...props} />
);

const FieldSeparator = (
  props: React.ComponentProps<typeof ShadcnFieldSeparator>
) => <ShadcnFieldSeparator {...props} />;

const FieldSet = (props: React.ComponentProps<typeof ShadcnFieldSet>) => (
  <ShadcnFieldSet {...props} />
);

const FieldContent = (
  props: React.ComponentProps<typeof ShadcnFieldContent>
) => <ShadcnFieldContent {...props} />;

const FieldTitle = (props: React.ComponentProps<typeof ShadcnFieldTitle>) => (
  <ShadcnFieldTitle {...props} />
);

export {
  Field,
  FieldLabel,
  FieldDescription,
  FieldError,
  FieldGroup,
  FieldLegend,
  FieldSeparator,
  FieldSet,
  FieldContent,
  FieldTitle,
};
